import { jsx as _jsx } from "react/jsx-runtime";
import { getImageUrl } from "@msys/common";
import { ImageList } from "@mui/material";
import { is3dModel, isImage, } from "../attachments/helpers.js";
import { ImageListItem } from "../image/ImageListItem.js";
import { ThreeDGenericImage } from "../threeD/ThreeDGenericImage.js";
const DEFAULT_IMAGE_SIZE = 240; // TODO: is this a good generic value
export const GalleryRow = ({ images, handleClick, maxItems, selectedIndex, imageHeight, aspectRatio, style, idPrefix = "msys-gallery-row-", objectFit, }) => {
    const imagesList = maxItems ? images.slice(0, maxItems) : images;
    const width = maxItems
        ? "100%"
        : imageHeight
            ? images.length * imageHeight + (images.length - 1) * 4
            : "100%";
    const height = imageHeight;
    return images.length > 0 ? (_jsx(ImageList, { style: {
            height,
            width,
            flexGrow: 0,
            flexShrink: 0,
            userSelect: "none",
            ...style,
        }, cols: maxItems ?? images.length, rowHeight: imageHeight, children: imagesList.map((image, index) => {
            const isMoreAmount = Boolean(maxItems &&
                images.length > maxItems &&
                index === imagesList.length - 1);
            return (_jsx(ImageListItem, { id: `${idPrefix}${image.id}`, onClick: handleClick
                    ? e => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleClick(index, image, isMoreAmount);
                    }
                    : undefined, role: Boolean(handleClick) && selectedIndex !== index
                    ? "button"
                    : "initial", "$clickable": true, "$selected": selectedIndex === index, "$moreAmount": isMoreAmount ? Math.min(images.length - maxItems, 99) : undefined, "$aspectRatio": aspectRatio, children: isImage(image) ? (_jsx("img", { draggable: false, src: getImageUrl({
                        url: image.url,
                        height: height ?? DEFAULT_IMAGE_SIZE,
                    }), srcSet: `${getImageUrl({
                        url: image.url,
                        height: height ?? DEFAULT_IMAGE_SIZE,
                        scaling: 2,
                    })} 2x`, alt: image.title, loading: "lazy", style: {
                        objectFit,
                        height: objectFit === "contain" ? "100%" : "auto",
                    } })) : is3dModel(image) ? (_jsx(ThreeDGenericImage, {})) : null }, image.id));
        }) })) : null;
};
//# sourceMappingURL=GalleryRow.js.map